import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../Common/Loader';

class Dimmer extends React.Component {
    render() {
        if (this.props.active) {
            return (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    backgroundColor: 'rgba(0,0,0,.5)',
                    color: '#fff',
                    zIndex: 10000
                }}>
                    <div style={{
                        marginTop: '150px',
                        textAlign: 'center',
                    }}>
                        <Loader loading={true} size={'150px'} />
                    </div>
                </div>
            );
        } else {
            return (<div> </div>);
        }
    }
};

Dimmer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default Dimmer;